import { atom } from "recoil";

export const DetailAboutState = atom({
  key: "DetailAboutState",
  default: undefined,
});
